import { allVmsSelector } from '_store/pmv/selectors';
import { vmsDisplayName } from '_store/pmv/pmvsTypes';
import managePmvFormReducer from '_store/forms/manage-pmv';
import { useLocalization } from '@fluent/react';
import { usePmvL10n } from '../../../hooks/usePmvL10n';
import { Box, Button, CardContent, CardHeader, IconButton } from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import CloseIcon from '@material-ui/icons/Close';
import React, { FC, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import PmvManage from './PmvManage';
import styles from './styles';
import { PmvCrudType, PmvCrudTypeEnum } from './types';

const PmvLayout: FC<PmvCrudType> = ({ id, type, onGoingBack, onClose }) => {
  const { l10n } = useLocalization();
  const { getPmvString } = usePmvL10n();
  const classes = styles();
  const dispatch = useDispatch();
  const allVms = useSelector(allVmsSelector);

  useEffect(() => {
    if (type === PmvCrudTypeEnum.NEW_PMV) {
      dispatch(managePmvFormReducer.actions.resetForm());
    }
  }, [type, dispatch]);

  const cardHeaderTitle = useMemo(() => {
    if (type !== PmvCrudTypeEnum.UPDATE_PMV || !id) {
      return getPmvString('forms-pmv-add-new');
    }

    const vms = allVms.find((item) => item.id === id);
    return `${getPmvString('forms-pmv-update')} ${vms ? vmsDisplayName(vms) : ''}`;
  }, [allVms, getPmvString, id, type]);

  return (
    <CardContent className={classes.cardContent}>
      <Box className={classes.box}>
        <Button
          variant="text"
          onClick={onGoingBack}
          size="small"
          className={classes.backBnt}
          startIcon={<ArrowBackIosIcon />}
        >
          {l10n.getString('back')}
        </Button>

        <IconButton className={classes.closeBnt} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      <CardHeader
        title={cardHeaderTitle}
        className={classes.header}
        titleTypographyProps={{ variant: 'h6' }}
      />

      <PmvManage id={id} type={type} />
    </CardContent>
  );
};

export default React.memo(PmvLayout);
